import { i18n } from '@/plugins';
import { util } from '@/app/shared/utils';

export class MenuItems {
  public items = [
    {
      title: i18n.t('titles.menu.contracts'),
      name: 'contracts',
      icon: 'mdi-file-document',
    },
  ];
  constructor() {
    this.loadMenuItemsByPermission();
  }
  public loadMenuItemsByPermission() {
    if (util.hasPermission('FI032')) {
      this.items.push({
        title: i18n.t('titles.menu.refunds_operation'),
        name: 'refunds_operation',
        icon: 'mdi-cash-refund',
      });
    }
  }
}
